import { firebaseReducer } from 'react-redux-firebase'
import { firestoreReducer } from 'redux-firestore'
import analytics from 'shared/analytics/reducer'
import createAction from '@f/create-action'
import userReducer from 'shared/ducks/user'
import sessionReducer from 'ducks/session'
import { combineReducers } from 'redux'

const setAccessToken = createAction('SET_ACCESS_TOKEN')

function auth (state = {}, action) {
  switch (action.type) {
    case setAccessToken.type:
      return {
        ...state,
        access_token: action.payload
      }
  }
  return state
}

export default combineReducers({
  firestore: firestoreReducer,
  firebase: firebaseReducer,
  session: sessionReducer,
  user: userReducer,
  analytics,
  auth
})

export { setAccessToken }
